import {ActionTypes} from '../actions';
import {ActionTypes as PartTypes} from '../../partsMaster/actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loading': false,
  'loadingComposition': false,
  'partCode': '',
  'quantity': 1,
  'wasSearched': false,
  'wasCreated': false,
  'createdOrder': null,
  'original': null,
  'substitute': null,
  'equivalences': [],
  'composition': [],
  'selectedCode': '',
  'parts': [],
};

export const dealerEmergingOrders = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.RESTORE_DEALER_EMERGING_ORDERS_PAGE]: (state, action) => (INITIAL_STATE),
    [ActionTypes.UPDATE_DEALER_EMERGING_ORDER_VALUE]: (state, action) => ({
      ...state,
      [action.payload.field]: action.payload.value,
    }),
    [ActionTypes.SELECT_DEALER_EMERGING_ORDER_CODE]: (state, action) => ({
      ...state,
      'selectedCode': action.payload,
    }),
    [ActionTypes.SEARCH_DEALER_EMERGING_ORDER_REQUEST]: (state, action) => ({
      ...state,
      'loading': true,
      'selectedCode': '',
    }),
    [ActionTypes.SEARCH_DEALER_EMERGING_ORDER_SUCCESS]: (state, action) => ({
      ...state,
      'loading': false,
      'wasSearched': true,
      'parts': action.response.data,
    }),
    [ActionTypes.SEARCH_DEALER_EMERGING_ORDER_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'wasSearched': false,
      'original': null,
      'substitute': null,
      'equivalences': [],
    }),
    [ActionTypes.CREATE_DEALER_EMERGING_ORDER_REQUEST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.CREATE_DEALER_EMERGING_ORDER_SUCCESS]: (state, action) => ({
      ...state,
      'loading': false,
      'wasCreated': true,
      'createdOrder': action.response.data,
      'original': null,
      'substitute': null,
      'equivalences': [],
    }),
    [ActionTypes.CREATE_DEALER_EMERGING_ORDER_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.TOGGLE_CREATED_DEALER_EMERGING_MODAL]: (state, action) => {
      return state.wasCreated ? INITIAL_STATE : {...state, 'wasCreated': !state.wasCreated};
    },
    [PartTypes.GET_PART_SPECIAL_SUBSTITUTES_REQUEST]: (state, action) => ({
      ...state,
      'loadingComposition': true,
    }),
    [PartTypes.GET_PART_SPECIAL_SUBSTITUTES_SUCCESS]: (state, action) => ({
      ...state,
      'loadingComposition': false,
      'composition': action.response.data,
    }),
    [PartTypes.GET_PART_SPECIAL_SUBSTITUTES_FAILED]: (state, action) => ({
      ...state,
      'loadingComposition': false,
      'composition': [],
    }),
  })(state, action);
};
